import { Container } from './style'

import PrimaryLayout from './primary/index'
import SecondaryLayout from './secondary/index'
import ThirdLayout from './third/index'

interface ILayout {
  layout?: 'primary' | 'secondary' | 'third'
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>
}

function Layout(props: ILayout) {
  return (
    <Container dir="rtl">
      {props.layout === 'primary' ? (
        <PrimaryLayout>{props.children}</PrimaryLayout>
      ) : props.layout === 'secondary' ? (
        <SecondaryLayout>{props.children}</SecondaryLayout>
      ) : props.layout === 'third' ? (
        <ThirdLayout>{props.children}</ThirdLayout>
      ) : (
        <>{props.children}</>
      )}
    </Container>
  )
}

export default Layout
